export const enum SortCondition {
  ASC = 'created_asc',
  DESC = 'created_desc',
  ASCEND = 'ascend',
  DESCEND = 'descend',
}
